import React from 'react';
import './Navbar.css';

interface NavbarProps {
  apiStatus: {
    status: 'online' | 'offline' | 'checking';
    message: string;
  };
  isFallback?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ apiStatus, isFallback }) => {
  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <div className="logo">
            <h2>K9HKR Studios</h2>
          </div>
          <div className="nav-links">
            <a href="#about">About</a>
            <a href="#services">Services</a>
            <a href="#projects">Projects</a>
            <a href="#contact">Contact</a>
          </div>
          <div className="api-status">
            <span className={`status ${apiStatus.status}`}>
              <span className="status-indicator">
                {apiStatus.status === 'online' ? '🟢' :
                  apiStatus.status === 'offline' ? '🔴' : '🟡'}
              </span>
              {apiStatus.message}
            </span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
